const RATINGS = [5, 4, 3, 2, 1]

export default RATINGS
